import {
	Button,
	Portal,
	Snackbar,
	TextField,
	Switch,
	IconButton,
	makeStyles,
	Typography,
	Tooltip,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from "@material-ui/core";
import LensIcon from "@material-ui/icons/Lens";
import React, { useEffect, useState } from "react";
import { HuePicker } from "react-color";
import { mdiShapePolygonPlus } from "@mdi/js";
import Icon from "@mdi/react";
import MuiAlert from "@material-ui/lab/Alert";
import { useActions, useValues } from "kea";

import geofencelogic from "src/store/geofence";
import { preferenceslogic } from "src/store/global";
import checkRole from "src/utils/checkRole";

import profilelogic from "src/store/profile";

const google = window.google;

const MIN_POLYGON_POINTS = 3;
const CLOSE_CLICK_TOLERANCE_PX = 20;

const getDistanceMeters = (latLngA, latLngB) => {
	const toRadians = (degrees) => (degrees * Math.PI) / 180;
	const earthRadius = 6371000;
	const dLat = toRadians(latLngB.lat() - latLngA.lat());
	const dLng = toRadians(latLngB.lng() - latLngA.lng());
	const lat1 = toRadians(latLngA.lat());
	const lat2 = toRadians(latLngB.lat());
	const haversine =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);

	return 2 * earthRadius * Math.asin(Math.sqrt(haversine));
};

const getCloseThresholdMeters = (map, latitude) => {
	const zoom = map.getZoom();
	const metersPerPixel =
		(156543.03392 * Math.cos((latitude * Math.PI) / 180)) / Math.pow(2, zoom);

	return CLOSE_CLICK_TOLERANCE_PX * metersPerPixel;
};

let new_geofence = null;

const empty_geofence = {
	name: "",
	coordinates: [],
	type: "Polygon",
	properties: {
		fillColor: "#3f51b5",
		strokeColor: "#3f51b5",
	},
};

const useStyles = makeStyles(() => ({
	popover: {
		position: "absolute",
		zIndex: "99999",
	},
	cover: {
		position: "fixed",
		top: "0px",
		right: "0px",
		bottom: "0px",
		left: "0px",
	},
	picker: {
		position: "fixed",
		width: "400px",
	},
}));

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const DrawTools = () => {
	const classes = useStyles();

	const { create } = useActions(geofencelogic);

	const { vehicle, geofence, asset } = useValues(preferenceslogic);
	const { setVehicle, setGeofence, setAsset } = useActions(preferenceslogic);

	const { profile } = useValues(profilelogic);

	const [geofenceDialog, setGeofenceDialog] = useState(false);

	const [newGeofence, setNewGeofence] = useState(empty_geofence);
	const [displayFillColorPicker, setDisplayFillColorPicker] = useState(false);
	const [displayStrokeColorPicker, setDisplayStrokeColorPicker] = useState(
		false,
	);

	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [drawingMode, setDrawingMode] = useState(null);

	const [render_show_buttons, set_render_show_buttons] = useState(true);

	const handleCloseSnackbar = (_event, reason) => {
		if (reason === "clickaway") {
			return;
		}
		setOpenSnackbar(false);
	};

	const handleGeofenceDraw = () => {
		setDrawingMode((current) => (current ? null : "polygon"));
	};

	const handleClose = () => {
		setGeofenceDialog(false);
		new_geofence.setMap(null);
		setNewGeofence(empty_geofence);
		setDrawingMode(null);
	};

	const handleCreate = () => {
		if (newGeofence.name === "") {
			// handleOpenSnackbar();
			return;
		}
		setGeofenceDialog(false);
		new_geofence.setMap(null);
		create({
			name: newGeofence.name,
			polygon: {
				coordinates: newGeofence.coordinates,
				properties: newGeofence.properties,
				type: newGeofence.type,
			},
		});
		setNewGeofence(empty_geofence);
	};

	const handleCancel = () => {
		setGeofenceDialog(false);
		setNewGeofence(empty_geofence);
		new_geofence.setMap(null);
		setDrawingMode(null);
	};

	const handleFillcolorPicker = () => {
		setDisplayFillColorPicker(!displayFillColorPicker);
	};

	const handleFillcolorPickerClose = () => {
		setDisplayFillColorPicker(false);
	};

	const handleFillcolorPickerChange = (color) => {
		let updated_geofence = { ...newGeofence };
		updated_geofence.properties.fillColor = color.hex;
		setNewGeofence(updated_geofence);
	};

	const handleStrokecolorPicker = () => {
		setDisplayStrokeColorPicker(!displayStrokeColorPicker);
	};

	const handleStrokecolorPickerClose = () => {
		setDisplayStrokeColorPicker(false);
	};

	const handleStrokecolorPickerChange = (color) => {
		let updated_geofence = { ...newGeofence };
		updated_geofence.properties.strokeColor = color.hex;
		setNewGeofence(updated_geofence);
	};

	// const handleGeofenceDrawHelpClose = (_event, reason) => {
	// 	if (reason === 'clickaway') {
	// 		return;
	// 	}
	// 	handleGeofenceDraw();
	// }

	useEffect(() => {
		if (global.gmap && render_show_buttons) {
			const button_group = document.getElementById("button_group");
			global.gmap.controls[google.maps.ControlPosition.TOP_RIGHT].push(
				button_group,
			);
			set_render_show_buttons(false);
		}
	}, [global.gmap]); // eslint-disable-line

	useEffect(() => {
		if (drawingMode !== "polygon" || !global.gmap) {
			return undefined;
		}

		const map = global.gmap;
		const vertices = [];
		const vertexMarkers = [];
		let previewPolyline = null;
		let firstVertexMarker = null;
		let firstMarkerHighlighted = false;
		let firstMarkerClickListener = null;
		const listeners = [];

		const getFirstLatLng = () =>
			new google.maps.LatLng(vertices[0].lat, vertices[0].lng);

		const getVertexMarkerIcon = ({ isFirst = false, closable = false } = {}) => {
			const fillColor = closable ? "#4caf50" : isFirst ? "#ffffff" : "#3f51b5";

			return {
				path: google.maps.SymbolPath.CIRCLE,
				scale: closable ? 10 : isFirst ? 7 : 6,
				fillColor,
				fillOpacity: 1,
				strokeColor: closable ? "#2e7d32" : "#3f51b5",
				strokeWeight: 2,
			};
		};

		const isNearFirstPoint = (latLng) => {
			if (vertices.length < MIN_POLYGON_POINTS) {
				return false;
			}

			const firstLatLng = getFirstLatLng();
			const thresholdMeters = getCloseThresholdMeters(map, vertices[0].lat);

			return getDistanceMeters(latLng, firstLatLng) <= thresholdMeters;
		};

		const createVertexMarker = (
			latLng,
			{ isFirst = false, closable = false, clickable = false } = {},
		) =>
			new google.maps.Marker({
				position: latLng,
				map,
				clickable,
				cursor: closable ? "pointer" : undefined,
				icon: getVertexMarkerIcon({ isFirst, closable }),
				zIndex: closable ? 3 : 2,
			});

		const enableFirstVertexClose = () => {
			if (!firstVertexMarker || firstMarkerClickListener) {
				return;
			}

			firstVertexMarker.setClickable(true);
			firstVertexMarker.setZIndex(3);
			firstMarkerClickListener = firstVertexMarker.addListener("click", () => {
				completePolygon();
			});
		};

		const setFirstVertexHighlighted = (highlighted) => {
			if (!firstVertexMarker || firstMarkerHighlighted === highlighted) {
				return;
			}

			firstMarkerHighlighted = highlighted;
			firstVertexMarker.setIcon(
				getVertexMarkerIcon({ isFirst: true, closable: highlighted }),
			);
		};

		const ensureFirstVertexMarker = () => {
			if (vertices.length === 0) {
				return;
			}

			const firstLatLng = getFirstLatLng();
			const canClose = vertices.length >= MIN_POLYGON_POINTS;

			if (!firstVertexMarker) {
				firstVertexMarker = createVertexMarker(firstLatLng, {
					isFirst: true,
					clickable: false,
				});
			}

			if (canClose) {
				enableFirstVertexClose();
			}
		};

		const clearDrawingOverlays = () => {
			if (previewPolyline) {
				previewPolyline.setMap(null);
				previewPolyline = null;
			}

			vertexMarkers.forEach((marker) => marker.setMap(null));
			vertexMarkers.length = 0;

			if (firstMarkerClickListener) {
				google.maps.event.removeListener(firstMarkerClickListener);
				firstMarkerClickListener = null;
			}

			if (firstVertexMarker) {
				firstVertexMarker.setMap(null);
				firstVertexMarker = null;
			}

			firstMarkerHighlighted = false;
		};

		const updatePreviewLine = (cursorLatLng) => {
			if (vertices.length === 0) {
				if (previewPolyline) {
					previewPolyline.setMap(null);
					previewPolyline = null;
				}
				return;
			}

			const path = vertices.map(
				(vertex) => new google.maps.LatLng(vertex.lat, vertex.lng),
			);

			if (cursorLatLng) {
				path.push(cursorLatLng);
			}

			if (!previewPolyline) {
				previewPolyline = new google.maps.Polyline({
					path,
					map,
					clickable: false,
					strokeColor: "#3f51b5",
					strokeOpacity: 0.8,
					strokeWeight: 2,
					icons: [
						{
							icon: {
								path: "M 0,-1 0,1",
								strokeOpacity: 0.6,
								scale: 2,
							},
							offset: "0",
							repeat: "12px",
						},
					],
				});
			} else {
				previewPolyline.setPath(path);
			}
		};

		const completePolygon = () => {
			if (vertices.length < MIN_POLYGON_POINTS) {
				return;
			}

			clearDrawingOverlays();

			const polygon = new google.maps.Polygon({
				paths: vertices.map((vertex) => ({
					lat: vertex.lat,
					lng: vertex.lng,
				})),
				map,
				clickable: false,
			});

			new_geofence = polygon;
			const new_polygon = [
				vertices.map((vertex) => [vertex.lng, vertex.lat]),
			];
			setNewGeofence((prev) => ({ ...prev, coordinates: new_polygon }));
			setGeofenceDialog(true);
			setDrawingMode(null);
		};

		map.setOptions({
			draggableCursor: "crosshair",
			disableDoubleClickZoom: true,
		});

		listeners.push(
			map.addListener("mousemove", (event) => {
				updatePreviewLine(event.latLng);

				if (vertices.length >= MIN_POLYGON_POINTS) {
					setFirstVertexHighlighted(isNearFirstPoint(event.latLng));
				}
			}),
		);

		listeners.push(
			map.addListener("click", (event) => {
				const latLng = event.latLng;

				if (isNearFirstPoint(latLng)) {
					completePolygon();
					return;
				}

				vertices.push({
					lat: latLng.lat(),
					lng: latLng.lng(),
				});

				if (vertices.length === 1) {
					ensureFirstVertexMarker();
				} else {
					vertexMarkers.push(
						createVertexMarker(latLng, { clickable: false }),
					);
					ensureFirstVertexMarker();
				}

				updatePreviewLine(latLng);
			}),
		);

		return () => {
			listeners.forEach((listener) =>
				google.maps.event.removeListener(listener),
			);
			clearDrawingOverlays();
			map.setOptions({
				draggableCursor: null,
				disableDoubleClickZoom: false,
			});
		};
	}, [drawingMode]);

	return (
		<>
			<Portal>
				<Snackbar
					open={openSnackbar}
					style={{ zIndex: 1400 }}
					autoHideDuration={6000}
				>
					<Alert onClose={handleCloseSnackbar} severity="error">
						Please provide a Name.
					</Alert>
				</Snackbar>
			</Portal>
			<div
				id="button_group"
				style={{
					display: "flex",
					flexGrow: "1",
				}}
			>
				{checkRole(profile, ["GeofenceEdit"]) && (
					<div
						style={{
							marginTop: "10px",
							marginRight: "10px",
							backgroundColor: "#fff",
							border: "2px solid #fff",
							borderRadius: "3px",
							boxShadow: "0 2px 6px rgba(0,0,0,.3)",
						}}
					>
						<Tooltip title="Start/Stop drawing a Geofence">
							<Button
								onClick={handleGeofenceDraw}
								style={{ padding: "5px" }}
								startIcon={<Icon path={mdiShapePolygonPlus} size={1}></Icon>}
							>
								{drawingMode === "polygon" ? "Stop Drawing" : "Create Geofence"}
							</Button>
						</Tooltip>
					</div>
				)}
				{(checkRole(profile, ["GeofenceView", "GeofenceEdit"]) ||
					checkRole(profile, ["VehicleView", "VehicleEdit"]) ||
					checkRole(profile, ["AssetView", "AssetEdit"])) && (
					<div
						style={{
							marginTop: "10px",
							marginRight: "10px",
							padding: "5px",
							display: "flex",
							flexGrow: "1",
							backgroundColor: "#fff",
							border: "2px solid #fff",
							borderRadius: "3px",
							boxShadow: "0 2px 6px rgba(0,0,0,.3)",
							cursor: "pointer",
							textAlign: "center",
						}}
					>
						{checkRole(profile, ["AssetView", "AssetEdit"]) && (
							<>
								<Typography>ASSETS</Typography>
								<Tooltip title="Show the Asset Panel">
									<Switch
										size="small"
										color="primary"
										checked={asset.show}
										onChange={() =>
											setAsset({
												...asset,
												show: !asset.show,
												position: { x: 10, y: 120 },
											})
										}
									/>
								</Tooltip>
							</>
						)}
						{checkRole(profile, ["VehicleView", "VehicleEdit"]) && (
							<>
								<Typography>VEHICLES</Typography>
								<Tooltip title="Show the Vehicle Panel">
									<Switch
										size="small"
										color="primary"
										checked={vehicle.show}
										onChange={() =>
											setVehicle({
												...vehicle,
												show: !vehicle.show,
												position: { x: 10, y: 240 },
											})
										}
									/>
								</Tooltip>
							</>
						)}
						{checkRole(profile, ["GeofenceView", "GeofenceEdit"]) && (
							<>
								<Typography>GEOFENCES</Typography>
								<Tooltip title="Show the Geofence Panel">
									<Switch
										size="small"
										color="primary"
										checked={geofence.show}
										onChange={() =>
											setGeofence({
												...geofence,
												show: !geofence.show,
												position: { x: 10, y: 360 },
											})
										}
									/>
								</Tooltip>
							</>
						)}
					</div>
				)}
			</div>
			<Snackbar open={drawingMode && checkRole(profile, ["GeofenceEdit"])}>
				<Alert severity="info">
					Click to add points. Click the first point again to finish.
				</Alert>
			</Snackbar>
			<Dialog
				open={geofenceDialog}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Assign properties to a new Geofence.
				</DialogTitle>
				<DialogContent>
					<TextField
						margin="dense"
						label="Geofence Name"
						type="text"
						fullWidth
						value={newGeofence.name}
						error={newGeofence.name === "" ? true : false}
						helperText={newGeofence.name === "" ? "Required" : null}
						onChange={(e) =>
							setNewGeofence({ ...newGeofence, name: e.target.value })
						}
						inputProps={{
							maxLength: 24,
						}}
					/>
					<Typography>
						Fill Colour:
						<IconButton aria-label="settings" onClick={handleFillcolorPicker}>
							<LensIcon style={{ color: newGeofence.properties.fillColor }} />
						</IconButton>
					</Typography>
					{displayFillColorPicker ? (
						<div className={classes.popover}>
							<div
								className={classes.cover}
								onClick={handleFillcolorPickerClose}
							/>
							<div
								style={{
									padding: "5px",
									backgroundColor: "#ffffff",
									boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
								}}
							>
								<HuePicker
									width={220}
									color={newGeofence.properties.fillColor}
									onChange={handleFillcolorPickerChange}
								/>
							</div>
						</div>
					) : null}
					<Typography>
						Border Colour:
						<IconButton aria-label="settings" onClick={handleStrokecolorPicker}>
							<LensIcon style={{ color: newGeofence.properties.strokeColor }} />
						</IconButton>
					</Typography>

					{displayStrokeColorPicker ? (
						<div className={classes.popover}>
							<div
								className={classes.cover}
								onClick={handleStrokecolorPickerClose}
							/>
							<div
								style={{
									padding: "5px",
									backgroundColor: "#ffffff",
									boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
								}}
							>
								<HuePicker
									width={220}
									color={newGeofence.properties.strokeColor}
									onChange={handleStrokecolorPickerChange}
								/>
							</div>
						</div>
					) : null}
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCancel} color="primary">
						Cancel
					</Button>
					<Button onClick={handleCreate} color="primary">
						Create
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default DrawTools;
